module.exports = __webpack_public_path__ + "assets/HKNova-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Regular.woff
// module id = 109
// module chunks = 0